export const transformations = [
    {
      "job": "academic",
      "code": "11-9033.00",
      "title": "Education Administrators, Postsecondary"
    },
    {
      "job": "account executive",
      "code": "41-3031.01",
      "title": "Sales Agents, Securities and Commodities"
    },
    {
      "job": "account manager",
      "code": "41-3031.01",
      "title": "Sales Agents, Securities and Commodities"
    },
    {
      "job": "accountant",
      "code": "13-2011.01",
      "title": "Accountants"
    },
    {
      "job": "actor",
      "code": "27-2011.00",
      "title": "Actors"
    },
    {
      "job": "actuary",
      "code": "15-2011.00",
      "title": "Actuaries"
    },
    {
      "job": "administrator",
      "code": "43-9061.00",
      "title": "Office Clerks, General"
    },
    {
      "job": "admission clerk",
      "code": "43-4071.00",
      "title": "File Clerks"
    },
    {
      "job": "advertising",
      "code": "11-2011.00",
      "title": "Advertising and Promotions Managers"
    },
    {
      "job": "advertising and marketing professional",
      "code": "11-2021.00",
      "title": "Marketing Managers"
    },
    {
      "job": "advertising creative",
      "code": "11-2011.00",
      "title": "Advertising and Promotions Managers"
    },
    {
      "job": "advertising professional",
      "code": "11-2011.00",
      "title": "Advertising and Promotions Managers"
    },
    {
      "job": "aerospace engineer",
      "code": "17-2011.00",
      "title": "Aerospace Engineers"
    },
    {
      "job": "aged and disabled carer",
      "code": "39-9021.00",
      "title": "Personal Care Aides"
    },
    {
      "job": "aged care worker",
      "code": "39-9021.00",
      "title": "Personal Care Aides"
    },
    {
      "job": "animal carer",
      "code": "39-2021.00",
      "title": "Nonfarm Animal Caretakers"
    },
    {
      "job": "animal keeper",
      "code": "39-2021.00",
      "title": "Nonfarm Animal Caretakers"
    },
    {
      "job": "animal trainer",
      "code": "39-2011.00",
      "title": "Animal Trainers"
    },
    {
      "job": "animator",
      "code": "27-1014.00",
      "title": "Multimedia Artists and Animators"
    },
    {
      "job": "arborist",
      "code": "37-3013.00",
      "title": "Tree Trimmers and Pruners"
    },
    {
      "job": "archaeologist",
      "code": "19-3091.02",
      "title": "Archeologists"
    },
    {
      "job": "architect",
      "code": "17-1011.00",
      "title": "Architects, Except Landscape and Naval"
    },
    {
      "job": "archivist",
      "code": "25-4011.00",
      "title": "Archivists"
    },
    {
      "job": "art director",
      "code": "27-1011.00",
      "title": "Art Directors"
    },
    {
      "job": "art lead",
      "code": "27-1014.00",
      "title": "Multimedia Artists and Animators"
    },
    {
      "job": "artist",
      "code": "27-1013.00",
      "title": "Fine Artists, Including Painters, Sculptors, and Illustrators"
    },
    {
      "job": "athlete",
      "code": "27-2021.00",
      "title": "Athletes and Sports Competitors"
    },
    {
      "job": "audio engineer",
      "code": "27-4014.00",
      "title": "Sound Engineering Technicians"
    },
    {
      "job": "audiologist",
      "code": "29-1181.00",
      "title": "Audiologists"
    },
    {
      "job": "auditor",
      "code": "13-2011.02",
      "title": "Auditors"
    },
    {
      "job": "author",
      "code": "27-3043.00",
      "title": "Writers and Authors"
    },
    {
      "job": "backend developer",
      "code": "15-1133.00",
      "title": "Software Developers, Systems Software"
    },
    {
      "job": "bank teller",
      "code": "43-3071.00",
      "title": "Tellers"
    },
    {
      "job": "banker",
      "code": "11-3031.02",
      "title": "Financial Managers, Branch or Department"
    },
    {
      "job": "barista",
      "code": "35-3022.01",
      "title": "Baristas"
    },
    {
      "job": "barrister",
      "code": "23-1011.00",
      "title": "Lawyers"
    },
    {
      "job": "beautician",
      "code": "39-5012.00",
      "title": "Hairdressers, Hairstylists, and Cosmetologists"
    },
    {
      "job": "beauty therapist",
      "code": "39-5012.00",
      "title": "Hairdressers, Hairstylists, and Cosmetologists"
    },
    {
      "job": "biotechnolgist",
      "code": "17-2031.00",
      "title": "Biomedical Engineers"
    },
    {
      "job": "blogger",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "book and script editor",
      "code": "27-3041.00",
      "title": "Editors"
    },
    {
      "job": "bookkeeper",
      "code": "43-3031.00",
      "title": "Bookkeeping, Accounting, and Auditing Clerks"
    },
    {
      "job": "botanist",
      "code": "19-1013.00",
      "title": "Soil and Plant Scientists"
    },
    {
      "job": "business advisor",
      "code": "13-1199.04",
      "title": "Business Continuity Planners"
    },
    {
      "job": "business analyst",
      "code": "15-1121.00",
      "title": "Computer Systems Analysts"
    },
    {
      "job": "business manager",
      "code": "11-1021.00",
      "title": "General and Operations Managers"
    },
    {
      "job": "business operator",
      "code": "13-1199.00",
      "title": "Business Operations Specialists, All Other"
    },
    {
      "job": "business owner",
      "code": "13-1199.00",
      "title": "Business Operations Specialists, All Other"
    },
    {
      "job": "business support",
      "code": "43-1011.00",
      "title": "First-Line Supervisors of Office and Administrative Support Workers"
    },
    {
      "job": "call centre representative",
      "code": "43-4051.00",
      "title": "Customer Service Representatives"
    },
    {
      "job": "camera operator",
      "code": "27-4031.00",
      "title": "Camera Operators, Television, Video, and Motion Picture"
    },
    {
      "job": "campaign coordinator",
      "code": "11-2011.00",
      "title": "Advertising and Promotions Managers"
    },
    {
      "job": "car detailer",
      "code": "53-7061.00",
      "title": "Cleaners of Vehicles and Equipment"
    },
    {
      "job": "career counselor",
      "code": "21-1012.00",
      "title": "Educational, Guidance, School, and Vocational Counselors"
    },
    {
      "job": "carpenter",
      "code": "47-2031.00",
      "title": "Carpenters"
    },
    {
      "job": "celebrant",
      "code": "27-3012.00",
      "title": "Public Address System and Other Announcers"
    },
    {
      "job": "checkout operator",
      "code": "41-2011.00",
      "title": "Cashiers"
    },
    {
      "job": "chemical engineer",
      "code": "17-2041.00",
      "title": "Chemical Engineers"
    },
    {
      "job": "chemist",
      "code": "19-2031.00",
      "title": "Chemists"
    },
    {
      "job": "chief executive officer",
      "code": "11-1011.00",
      "title": "Chief Executives"
    },
    {
      "job": "chief information officer",
      "code": "11-1011.00",
      "title": "Chief Executives"
    },
    {
      "job": "chief technology officer",
      "code": "11-1011.00",
      "title": "Chief Executives"
    },
    {
      "job": "child care",
      "code": "39-9011.00",
      "title": "Childcare Workers"
    },
    {
      "job": "childcare worker",
      "code": "39-9011.00",
      "title": "Childcare Workers"
    },
    {
      "job": "choreographer",
      "code": "27-2032.00",
      "title": "Choreographers"
    },
    {
      "job": "cinematographer",
      "code": "27-2012.02",
      "title": "Directors- Stage, Motion Pictures, Television, and Radio"
    },
    {
      "job": "civil engineer",
      "code": "17-2051.00",
      "title": "Civil Engineers"
    },
    {
      "job": "clinical psychologist",
      "code": "19-3031.02",
      "title": "Clinical Psychologists"
    },
    {
      "job": "coach",
      "code": "27-2022.00",
      "title": "Coaches and Scouts"
    },
    {
      "job": "comedian",
      "code": "27-2011.00",
      "title": "Actors"
    },
    {
      "job": "computer technician",
      "code": "15-1151.00",
      "title": "Computer User Support Specialists"
    },
    {
      "job": "conference and event organizer",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "conference and event planner",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "conference coordinator",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "conservator",
      "code": "25-4013.00",
      "title": "Museum Technicians and Conservators"
    },
    {
      "job": "construction estimator",
      "code": "13-1051.00",
      "title": "Cost Estimators"
    },
    {
      "job": "construction worker",
      "code": "47-2061.00",
      "title": "Construction Laborers"
    },
    {
      "job": "consultant",
      "code": "13-1111.00",
      "title": "Management Analysts"
    },
    {
      "job": "conveyancer",
      "code": "23-2011.00",
      "title": "Paralegals and Legal Assistants"
    },
    {
      "job": "cook",
      "code": "35-2014.00",
      "title": "Cooks, Restaurant"
    },
    {
      "job": "copywriter",
      "code": "27-3043.04",
      "title": "Copy Writers"
    },
    {
      "job": "corporate finance and investment banker",
      "code": "11-9199.03",
      "title": "Investment Fund Managers"
    },
    {
      "job": "corporate treasurer",
      "code": "11-3031.01",
      "title": "Treasurers and Controllers"
    },
    {
      "job": "corrections officer",
      "code": "33-3012.00",
      "title": "Correctional Officers and Jailers"
    },
    {
      "job": "cost clerk",
      "code": "43-3021.02",
      "title": "Billing, Cost, and Rate Clerks"
    },
    {
      "job": "courier",
      "code": "43-5021.00",
      "title": "Couriers and Messengers"
    },
    {
      "job": "creative agency director",
      "code": "11-2011.00",
      "title": "Advertising and Promotions Managers"
    },
    {
      "job": "creative director",
      "code": "27-1011.00",
      "title": "Art Directors"
    },
    {
      "job": "creative freelancer",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "credit and loan officer",
      "code": "13-2072.00",
      "title": "Loan Officers"
    },
    {
      "job": "critic",
      "code": "27-3022.00",
      "title": "Reporters and Correspondents"
    },
    {
      "job": "customer service",
      "code": "43-4051.00",
      "title": "Customer Service Representatives"
    },
    {
      "job": "customer service representative",
      "code": "43-4051.00",
      "title": "Customer Service Representatives"
    },
    {
      "job": "customer success",
      "code": "43-4051.00",
      "title": "Customer Service Representatives"
    },
    {
      "job": "dancer",
      "code": "27-2031.00",
      "title": "Dancers"
    },
    {
      "job": "data analyst",
      "code": "15-1199.08",
      "title": "Business Intelligence Analysts"
    },
    {
      "job": "data scientist",
      "code": "15-1111.00",
      "title": "Computer and Information Research Scientists"
    },
    {
      "job": "database administrator",
      "code": "15-1141.00",
      "title": "Database Administrators"
    },
    {
      "job": "dental assistant",
      "code": "31-9091.00",
      "title": "Dental Assistants"
    },
    {
      "job": "dental hygienist",
      "code": "29-2021.00",
      "title": "Dental Hygienists"
    },
    {
      "job": "designer",
      "code": "27-1024.00",
      "title": "Graphic Designers"
    },
    {
      "job": "developer",
      "code": "15-1131.00",
      "title": "Computer Programmers"
    },
    {
      "job": "digital designer",
      "code": "27-1024.00",
      "title": "Graphic Designers"
    },
    {
      "job": "doctor",
      "code": "29-1062.00",
      "title": "Family and General Practitioners"
    },
    {
      "job": "economist",
      "code": "19-3011.00",
      "title": "Economists"
    },
    {
      "job": "educational psychologist",
      "code": "19-3031.01",
      "title": "School Psychologists"
    },
    {
      "job": "electrical engineer",
      "code": "17-2071.00",
      "title": "Electrical Engineers"
    },
    {
      "job": "emergency services personnel",
      "code": "29-2041.00",
      "title": "Emergency Medical Technicians and Paramedics"
    },
    {
      "job": "entertainer",
      "code": "27-2011.00",
      "title": "Actors"
    },
    {
      "job": "entrepreneur",
      "code": "11-1021.00",
      "title": "General and Operations Managers"
    },
    {
      "job": "environmental consultant",
      "code": "19-2041.00",
      "title": "Environmental Scientists and Specialists, Including Health"
    },
    {
      "job": "event coordinator",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "event manager",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "event planner",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "event planner and coordinator",
      "code": "13-1121.00",
      "title": "Meeting, Convention, and Event Planners"
    },
    {
      "job": "executive assistant",
      "code": "43-6011.00",
      "title": "Executive Secretaries and Executive Administrative Assistants"
    },
    {
      "job": "facilitator",
      "code": "27-3012.00",
      "title": "Public Address System and Other Announcers"
    },
    {
      "job": "facilities manager",
      "code": "11-1021.00",
      "title": "General and Operations Managers"
    },
    {
      "job": "family support worker",
      "code": "21-1021.00",
      "title": "Child, Family, and School Social Workers"
    },
    {
      "job": "fashion designer",
      "code": "27-1022.00",
      "title": "Fashion Designers"
    },
    {
      "job": "filmmaker",
      "code": "27-2012.01",
      "title": "Producers"
    },
    {
      "job": "financial advisor",
      "code": "13-2052.00",
      "title": "Personal Financial Advisors"
    },
    {
      "job": "financial analyst",
      "code": "13-2051.00",
      "title": "Financial Analysts"
    },
    {
      "job": "financial manager",
      "code": "11-3031.02",
      "title": "Financial Managers, Branch or Department"
    },
    {
      "job": "financial planner",
      "code": "13-2052.00",
      "title": "Personal Financial Advisors"
    },
    {
      "job": "fire fighter",
      "code": "33-2011.01",
      "title": "Municipal Firefighters"
    },
    {
      "job": "firefighter",
      "code": "33-2011.01",
      "title": "Municipal Firefighters"
    },
    {
      "job": "flight crew",
      "code": "53-2031.00",
      "title": "Flight Attendants"
    },
    {
      "job": "florist",
      "code": "27-1023.00",
      "title": "Floral Designers"
    },
    {
      "job": "food technologist",
      "code": "19-1012.00",
      "title": "Food Scientists and Technologists"
    },
    {
      "job": "forensic investigator",
      "code": "19-4092.00",
      "title": "Forensic Science Technicians"
    },
    {
      "job": "forensic psychologist",
      "code": "19-3031.02",
      "title": "Clinical Psychologists"
    },
    {
      "job": "freelance creative",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "freelancer",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "front end developer",
      "code": "15-1134.00",
      "title": "Web Developers"
    },
    {
      "job": "gallery and museum curator",
      "code": "25-4012.00",
      "title": "Curators"
    },
    {
      "job": "gallery curator",
      "code": "25-4012.00",
      "title": "Curators"
    },
    {
      "job": "game designer",
      "code": "15-1199.11",
      "title": "Video Game Designers"
    },
    {
      "job": "game developer",
      "code": "15-1132.00",
      "title": "Software Developers, Applications"
    },
    {
      "job": "game director",
      "code": "27-1011.00",
      "title": "Art Directors"
    },
    {
      "job": "gardener",
      "code": "37-3011.00",
      "title": "Landscaping and Groundskeeping Workers"
    },
    {
      "job": "geologist",
      "code": "19-2042.00",
      "title": "Geoscientists, Except Hydrologists and Geographers"
    },
    {
      "job": "geophysicist",
      "code": "19-2042.00",
      "title": "Geoscientists, Except Hydrologists and Geographers"
    },
    {
      "job": "geotechnical engineer",
      "code": "17-2151.00",
      "title": "Mining and Geological Engineers, Including Mining Safety Engineers"
    },
    {
      "job": "glazier",
      "code": "47-2121.00",
      "title": "Glaziers"
    },
    {
      "job": "graphic design",
      "code": "27-1024.00",
      "title": "Graphic Designers"
    },
    {
      "job": "graphic designer",
      "code": "27-1024.00",
      "title": "Graphic Designers"
    },
    {
      "job": "greeter",
      "code": "39-3031.00",
      "title": "Ushers, Lobby Attendants, and Ticket Takers"
    },
    {
      "job": "guidance counselor",
      "code": "21-1012.00",
      "title": "Educational, Guidance, School, and Vocational Counselors"
    },
    {
      "job": "hair stylist",
      "code": "39-5012.00",
      "title": "Hairdressers, Hairstylists, and Cosmetologists"
    },
    {
      "job": "hardware technician",
      "code": "15-1151.00",
      "title": "Computer User Support Specialists"
    },
    {
      "job": "historian",
      "code": "19-3093.00",
      "title": "Historians"
    },
    {
      "job": "hospitality",
      "code": "35-9031.00",
      "title": "Hosts and Hostesses, Restaurant, Lounge, and Coffee Shop"
    },
    {
      "job": "hospitality worker",
      "code": "35-9031.00",
      "title": "Hosts and Hostesses, Restaurant, Lounge, and Coffee Shop"
    },
    {
      "job": "host",
      "code": "35-9031.00",
      "title": "Hosts and Hostesses, Restaurant, Lounge, and Coffee Shop"
    },
    {
      "job": "housekeeper",
      "code": "37-2012.00",
      "title": "Maids and Housekeeping Cleaners"
    },
    {
      "job": "human resources",
      "code": "13-1071.00",
      "title": "Human Resources Specialists"
    },
    {
      "job": "human resources assistant",
      "code": "13-1071.00",
      "title": "Human Resources Specialists"
    },
    {
      "job": "human resources professional",
      "code": "13-1071.00",
      "title": "Human Resources Specialists"
    },
    {
      "job": "hydrogeologist",
      "code": "19-2043.00",
      "title": "Hydrologists"
    },
    {
      "job": "ICT manager",
      "code": "15-1199.09",
      "title": "Information Technology Project Managers"
    },
    {
      "job": "ICT systems engineer",
      "code": "15-1199.02",
      "title": "Computer Systems Engineers/Architects"
    },
    {
      "job": "illustrator",
      "code": "27-1013.00",
      "title": "Fine Artists, Including Painters, Sculptors, and Illustrators"
    },
    {
      "job": "industrial and organizational psychologist",
      "code": "19-3032.00",
      "title": "Industrial-Organizational Psychologists"
    },
    {
      "job": "industrial designer",
      "code": "27-1021.00",
      "title": "Commercial and Industrial Designers"
    },
    {
      "job": "industrial engineer",
      "code": "17-2112.00",
      "title": "Industrial Engineers"
    },
    {
      "job": "industrial relations advisor",
      "code": "13-1041.03",
      "title": "Equal Opportunity Representatives and Officers"
    },
    {
      "job": "influencer",
      "code": "27-3031.00",
      "title": "Public Relations Specialists"
    },
    {
      "job": "innovation advisor",
      "code": "11-1011.00",
      "title": "Chief Executives"
    },
    {
      "job": "innovation lead",
      "code": "11-1011.00",
      "title": "Chief Executives"
    },
    {
      "job": "insurance risk consulting",
      "code": "13-2099.02",
      "title": "Risk Management Specialists"
    },
    {
      "job": "intelligence officer",
      "code": "33-3021.06",
      "title": "Intelligence Analysts"
    },
    {
      "job": "interior decorator",
      "code": "27-1025.00",
      "title": "Interior Designers"
    },
    {
      "job": "investment advisor",
      "code": "11-9199.03",
      "title": "Investment Fund Managers"
    },
    {
      "job": "investment analyst",
      "code": "11-9199.03",
      "title": "Investment Fund Managers"
    },
    {
      "job": "investment manager",
      "code": "11-9199.03",
      "title": "Investment Fund Managers"
    },
    {
      "job": "investor",
      "code": "11-9199.03",
      "title": "Investment Fund Managers"
    },
    {
      "job": "journalist",
      "code": "27-3022.00",
      "title": "Reporters and Correspondents"
    },
    {
      "job": "kindergarten teacher",
      "code": "25-2012.00",
      "title": "Kindergarten Teachers, Except Special Education"
    },
    {
      "job": "kitchenhand",
      "code": "35-2021.00",
      "title": "Food Preparation Workers"
    },
    {
      "job": "laboratory technician",
      "code": "29-2012.00",
      "title": "Medical and Clinical Laboratory Technicians"
    },
    {
      "job": "lawyer",
      "code": "23-1011.00",
      "title": "Lawyers"
    },
    {
      "job": "legal clerk",
      "code": "23-2011.00",
      "title": "Paralegals and Legal Assistants"
    },
    {
      "job": "legal secratary",
      "code": "43-6012.00",
      "title": "Legal Secretaries"
    },
    {
      "job": "librarian",
      "code": "25-4021.00",
      "title": "Librarians"
    },
    {
      "job": "library assistant",
      "code": "43-4121.00",
      "title": "Library Assistants, Clerical"
    },
    {
      "job": "linguist",
      "code": "27-3091.00",
      "title": "Interpreters and Translators"
    },
    {
      "job": "locksmith",
      "code": "49-9094.00",
      "title": "Locksmiths and Safe Repairers"
    },
    {
      "job": "logistics officer",
      "code": "13-1081.00",
      "title": "Logisticians"
    },
    {
      "job": "machine operator",
      "code": "51-4081.00",
      "title": "Multiple Machine Tool Setters, Operators, and Tenders, Metal and Plastic"
    },
    {
      "job": "management consultant",
      "code": "13-1111.00",
      "title": "Management Analysts"
    },
    {
      "job": "market research analyst",
      "code": "13-1161.00",
      "title": "Market Research Analysts and Marketing Specialists"
    },
    {
      "job": "marketing manager",
      "code": "11-2021.00",
      "title": "Marketing Managers"
    },
    {
      "job": "marketing professional",
      "code": "13-1161.00",
      "title": "Market Research Analysts and Marketing Specialists"
    },
    {
      "job": "master of ceremonies",
      "code": "27-3012.00",
      "title": "Public Address System and Other Announcers"
    },
    {
      "job": "mathematician",
      "code": "15-2021.00",
      "title": "Mathematicians"
    },
    {
      "job": "mechanic",
      "code": "49-3023.01",
      "title": "Automotive Master Mechanics"
    },
    {
      "job": "mechanical engineer",
      "code": "17-2141.00",
      "title": "Mechanical Engineers"
    },
    {
      "job": "media personality",
      "code": "27-2011.00",
      "title": "Actors"
    },
    {
      "job": "media producer",
      "code": "27-2012.01",
      "title": "Producers"
    },
    {
      "job": "media representative",
      "code": "27-3031.00",
      "title": "Public Relations Specialists"
    },
    {
      "job": "media strategy",
      "code": "27-3031.00",
      "title": "Public Relations Specialists"
    },
    {
      "job": "medical intake officer",
      "code": "43-6013.00",
      "title": "Medical Secretaries"
    },
    {
      "job": "metallurgist",
      "code": "19-2032.00",
      "title": "Materials Scientists"
    },
    {
      "job": "microbiologist",
      "code": "19-1022.00",
      "title": "Microbiologists"
    },
    {
      "job": "middle school educator",
      "code": "25-2022.00",
      "title": "Middle School Teachers, Except Special and Career/Technical Education"
    },
    {
      "job": "mining engineer",
      "code": "17-2151.00",
      "title": "Mining and Geological Engineers, Including Mining Safety Engineers"
    },
    {
      "job": "model",
      "code": "41-9012.00",
      "title": "Models"
    },
    {
      "job": "mortgage and loan broker",
      "code": "13-2072.00",
      "title": "Loan Officers"
    },
    {
      "job": "mortgage broker",
      "code": "13-2072.00",
      "title": "Loan Officers"
    },
    {
      "job": "motivational speaker",
      "code": "27-3012.00",
      "title": "Public Address System and Other Announcers"
    },
    {
      "job": "multimedia developer",
      "code": "27-1014.00",
      "title": "Multimedia Artists and Animators"
    },
    {
      "job": "music composer",
      "code": "27-2041.04",
      "title": "Music Composers and Arrangers"
    },
    {
      "job": "musician",
      "code": "27-2042.02",
      "title": "Musicians, Instrumental"
    },
    {
      "job": "network and system administrator",
      "code": "15-1142.00",
      "title": "Network and Computer Systems Administrators"
    },
    {
      "job": "neurologist",
      "code": "29-1069.04",
      "title": "Neurologists"
    },
    {
      "job": "neuropsychologist",
      "code": "19-3039.01",
      "title": "Neuropsychologists and Clinical Neuropsychologists"
    },
    {
      "job": "novelist",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "nurse",
      "code": "29-1141.00",
      "title": "Registered Nurses"
    },
    {
      "job": "nurse practitioner",
      "code": "29-1171.00",
      "title": "Nurse Practitioners"
    },
    {
      "job": "nursery laborer",
      "code": "45-2092.01",
      "title": "Nursery Workers"
    },
    {
      "job": "nutritionist",
      "code": "29-1031.00",
      "title": "Dietitians and Nutritionists"
    },
    {
      "job": "occupational therapist",
      "code": "29-1122.00",
      "title": "Occupational Therapists"
    },
    {
      "job": "office cashier",
      "code": "41-2011.00",
      "title": "Cashiers"
    },
    {
      "job": "office manager",
      "code": "11-3011.00",
      "title": "Administrative Services Managers"
    },
    {
      "job": "optometrist",
      "code": "29-1041.00",
      "title": "Optometrists"
    },
    {
      "job": "packer",
      "code": "53-7064.00",
      "title": "Packers and Packagers, Hand"
    },
    {
      "job": "panel beater",
      "code": "49-3021.00",
      "title": "Automotive Body and Related Repairers"
    },
    {
      "job": "pediatrician",
      "code": "29-1065.00",
      "title": "Pediatricians, General"
    },
    {
      "job": "performer",
      "code": "27-2011.00",
      "title": "Actors"
    },
    {
      "job": "personal assistant",
      "code": "43-6011.00",
      "title": "Executive Secretaries and Executive Administrative Assistants"
    },
    {
      "job": "personal investigator",
      "code": "33-9021.00",
      "title": "Private Detectives and Investigators"
    },
    {
      "job": "pest controller",
      "code": "37-2021.00",
      "title": "Pest Control Workers"
    },
    {
      "job": "pet groomer",
      "code": "39-2021.00",
      "title": "Nonfarm Animal Caretakers"
    },
    {
      "job": "pharmacist",
      "code": "29-1051.00",
      "title": "Pharmacists"
    },
    {
      "job": "philosopher",
      "code": "25-1126.00",
      "title": "Philosophy and Religion Teachers, Postsecondary"
    },
    {
      "job": "philosophy educator",
      "code": "25-1126.00",
      "title": "Philosophy and Religion Teachers, Postsecondary"
    },
    {
      "job": "photographer",
      "code": "27-4021.00",
      "title": "Photographers"
    },
    {
      "job": "photography",
      "code": "27-4021.00",
      "title": "Photographers"
    },
    {
      "job": "physician",
      "code": "29-1069.08",
      "title": "Physical Medicine and Rehabilitation Physicians"
    },
    {
      "job": "physicist",
      "code": "19-2012.00",
      "title": "Physicists"
    },
    {
      "job": "physiotherapist",
      "code": "29-1123.00",
      "title": "Physical Therapists"
    },
    {
      "job": "playwright",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "plumber",
      "code": "47-2152.02",
      "title": "Plumbers"
    },
    {
      "job": "podiatrist",
      "code": "29-1081.00",
      "title": "Podiatrists"
    },
    {
      "job": "police officer",
      "code": "33-3051.01",
      "title": "Police Patrol Officers"
    },
    {
      "job": "policy advisor",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "policy analyst",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "policy and planning manager",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "policy strategist",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "political analyst",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "political scientist",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "political strategist",
      "code": "19-3094.00",
      "title": "Political Scientists"
    },
    {
      "job": "private investigator",
      "code": "33-9021.00",
      "title": "Private Detectives and Investigators"
    },
    {
      "job": "process improvement auditor",
      "code": "13-1111.00",
      "title": "Management Analysts"
    },
    {
      "job": "producer",
      "code": "27-2012.01",
      "title": "Producers"
    },
    {
      "job": "product assembler",
      "code": "51-2022.00",
      "title": "Electrical and Electronic Equipment Assemblers"
    },
    {
      "job": "product designer",
      "code": "27-1024.00",
      "title": "Graphic Designers"
    },
    {
      "job": "product manager",
      "code": "15-1199.09",
      "title": "Information Technology Project Managers"
    },
    {
      "job": "product owner",
      "code": "15-1199.09",
      "title": "Information Technology Project Managers"
    },
    {
      "job": "production clerk",
      "code": "43-5061.00",
      "title": "Production, Planning, and Expediting Clerks"
    },
    {
      "job": "production coordinator",
      "code": "43-5061.00",
      "title": "Production, Planning, and Expediting Clerks"
    },
    {
      "job": "professional speaker",
      "code": "27-3012.00",
      "title": "Public Address System and Other Announcers"
    },
    {
      "job": "professor",
      "code": "11-9033.00",
      "title": "Education Administrators, Postsecondary"
    },
    {
      "job": "project administrator",
      "code": "11-3011.00",
      "title": "Administrative Services Managers"
    },
    {
      "job": "project coordinator",
      "code": "11-3011.00",
      "title": "Administrative Services Managers"
    },
    {
      "job": "project manager",
      "code": "15-1199.09",
      "title": "Information Technology Project Managers"
    },
    {
      "job": "psychiatrist",
      "code": "29-1066.00",
      "title": "Psychiatrists"
    },
    {
      "job": "psychologist",
      "code": "19-3031.02",
      "title": "Clinical Psychologists"
    },
    {
      "job": "public relations",
      "code": "27-3031.00",
      "title": "Public Relations Specialists"
    },
    {
      "job": "public relations analyst",
      "code": "27-3031.00",
      "title": "Public Relations Specialists"
    },
    {
      "job": "public relations manager",
      "code": "11-2031.00",
      "title": "Public Relations and Fundraising Managers"
    },
    {
      "job": "public relations professional",
      "code": "27-3031.00",
      "title": "Public Relations Specialists"
    },
    {
      "job": "quantity surveyor",
      "code": "17-1022.00",
      "title": "Surveyors"
    },
    {
      "job": "radio presenter",
      "code": "27-3011.00",
      "title": "Radio and Television Announcers"
    },
    {
      "job": "real estate agent",
      "code": "41-9022.00",
      "title": "Real Estate Sales Agents"
    },
    {
      "job": "receptionist",
      "code": "43-4171.00",
      "title": "Receptionists and Information Clerks"
    },
    {
      "job": "record manager",
      "code": "15-1199.12",
      "title": "Document Management Specialists"
    },
    {
      "job": "records manager",
      "code": "15-1199.12",
      "title": "Document Management Specialists"
    },
    {
      "job": "research and development",
      "code": "11-9121.00",
      "title": "Natural Sciences Managers"
    },
    {
      "job": "research assistant",
      "code": "19-3022.00",
      "title": "Survey Researchers"
    },
    {
      "job": "researcher",
      "code": "19-3022.00",
      "title": "Survey Researchers"
    },
    {
      "job": "researcher and development lead",
      "code": "11-9121.00",
      "title": "Natural Sciences Managers"
    },
    {
      "job": "retail buyer",
      "code": "13-1022.00",
      "title": "Wholesale and Retail Buyers, Except Farm Products"
    },
    {
      "job": "retail merchandiser",
      "code": "27-1026.00",
      "title": "Merchandise Displayers and Window Trimmers"
    },
    {
      "job": "retail pharmacist",
      "code": "29-1051.00",
      "title": "Pharmacists"
    },
    {
      "job": "risk and compliance analyst",
      "code": "13-2099.02",
      "title": "Risk Management Specialists"
    },
    {
      "job": "risk and compliance manager",
      "code": "11-9199.02",
      "title": "Compliance Managers"
    },
    {
      "job": "sales assistant",
      "code": "41-2031.00",
      "title": "Retail Salespersons"
    },
    {
      "job": "sales demonstrator",
      "code": "41-9011.00",
      "title": "Demonstrators and Product Promoters"
    },
    {
      "job": "sales executive",
      "code": "11-2022.00",
      "title": "Sales Managers"
    },
    {
      "job": "sales professional",
      "code": "11-2022.00",
      "title": "Sales Managers"
    },
    {
      "job": "sales representative",
      "code": "11-2022.00",
      "title": "Sales Managers"
    },
    {
      "job": "scheduler",
      "code": "43-5061.00",
      "title": "Production, Planning, and Expediting Clerks"
    },
    {
      "job": "school counselor",
      "code": "21-1012.00",
      "title": "Educational, Guidance, School, and Vocational Counselors"
    },
    {
      "job": "scientist",
      "code": "19-4091.00",
      "title": "Environmental Science and Protection Technicians, Including Health"
    },
    {
      "job": "screenwriter",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "scriptwriter",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "secretary",
      "code": "43-6014.00",
      "title": "Secretaries and Administrative Assistants, Except Legal, Medical, and Executive"
    },
    {
      "job": "shelf filler",
      "code": "43-5081.01",
      "title": "Stock Clerks, Sales Floor"
    },
    {
      "job": "social commentator",
      "code": "27-3021.00",
      "title": "Broadcast News Analysts"
    },
    {
      "job": "social worker",
      "code": "21-1022.00",
      "title": "Healthcare Social Workers"
    },
    {
      "job": "software engineer",
      "code": "15-1133.00",
      "title": "Software Developers, Systems Software"
    },
    {
      "job": "software tester",
      "code": "15-1199.01",
      "title": "Software Quality Assurance Engineers and Testers"
    },
    {
      "job": "solicitor",
      "code": "23-1011.00",
      "title": "Lawyers"
    },
    {
      "job": "solution architect",
      "code": "15-1199.02",
      "title": "Computer Systems Engineers/Architects"
    },
    {
      "job": "sports management",
      "code": "13-1011.00",
      "title": "Agents and Business Managers of Artists, Performers, and Athletes"
    },
    {
      "job": "statistician",
      "code": "15-2041.00",
      "title": "Statisticians"
    },
    {
      "job": "STEM professor",
      "code": "25-1032.00",
      "title": "Engineering Teachers, Postsecondary"
    },
    {
      "job": "STEM teacher",
      "code": "25-2031.00",
      "title": "Secondary School Teachers, Except Special and Career/Technical Education"
    },
    {
      "job": "stock trader",
      "code": "41-3031.03",
      "title": "Securities and Commodities Traders"
    },
    {
      "job": "stockbroker",
      "code": "41-3031.03",
      "title": "Securities and Commodities Traders"
    },
    {
      "job": "store clerk",
      "code": "43-5081.03",
      "title": "Stock Clerks- Stockroom, Warehouse, or Storage Yard"
    },
    {
      "job": "store merchandiser",
      "code": "27-1026.00",
      "title": "Merchandise Displayers and Window Trimmers"
    },
    {
      "job": "strategist",
      "code": "5-1199.08",
      "title": "Business Intelligence Analysts"
    },
    {
      "job": "student counselor",
      "code": "21-1012.00",
      "title": "Educational, Guidance, School, and Vocational Counselors"
    },
    {
      "job": "studio lead",
      "code": "27-2012.05",
      "title": "Technical Directors/Managers"
    },
    {
      "job": "stylist",
      "code": "39-5012.00",
      "title": "Hairdressers, Hairstylists, and Cosmetologists"
    },
    {
      "job": "surgeon",
      "code": "29-1067.00",
      "title": "Surgeons"
    },
    {
      "job": "systems administrator",
      "code": "15-1142.00",
      "title": "Network and Computer Systems Administrators"
    },
    {
      "job": "systems architect",
      "code": "15-1199.02",
      "title": "Computer Systems Engineers/Architects"
    },
    {
      "job": "talent acquisition specialist",
      "code": "13-1071.00",
      "title": "Human Resources Specialists"
    },
    {
      "job": "talk show host",
      "code": "27-3011.00",
      "title": "Radio and Television Announcers"
    },
    {
      "job": "tax agent",
      "code": "13-2081.00",
      "title": "Tax Examiners and Collectors, and Revenue Agents"
    },
    {
      "job": "teacher",
      "code": "25-2022.00",
      "title": "Middle School Teachers, Except Special and Career/Technical Education"
    },
    {
      "job": "technical writer",
      "code": "27-3042.00",
      "title": "Technical Writers"
    },
    {
      "job": "television presenter",
      "code": "27-3011.00",
      "title": "Radio and Television Announcers"
    },
    {
      "job": "theater director",
      "code": "27-2012.02",
      "title": "Directors- Stage, Motion Pictures, Television, and Radio"
    },
    {
      "job": "tour guide",
      "code": "39-7011.00",
      "title": "Tour Guides and Escorts"
    },
    {
      "job": "trader",
      "code": "41-3031.03",
      "title": "Securities and Commodities Traders"
    },
    {
      "job": "travel writer",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "truck driver",
      "code": "53-3032.00",
      "title": "Heavy and Tractor-Trailer Truck Drivers"
    },
    {
      "job": "tyre fitter",
      "code": "49-3023.02",
      "title": "Automotive Specialty Technicians"
    },
    {
      "job": "university educator",
      "code": "11-9033.00",
      "title": "Education Administrators, Postsecondary"
    },
    {
      "job": "university professor",
      "code": "11-9033.00",
      "title": "Education Administrators, Postsecondary"
    },
    {
      "job": "upholsterer",
      "code": "51-6093.00",
      "title": "Upholsterers"
    },
    {
      "job": "urban planner",
      "code": "19-3051.00",
      "title": "Urban and Regional Planners"
    },
    {
      "job": "user experience consultant",
      "code": "15-1134.00",
      "title": "Web Developers"
    },
    {
      "job": "ux developer",
      "code": "15-1134.00",
      "title": "Web Developers"
    },
    {
      "job": "ux researcher",
      "code": "15-1134.00",
      "title": "Web Developers"
    },
    {
      "job": "valuer",
      "code": "13-2021.02",
      "title": "Appraisers, Real Estate"
    },
    {
      "job": "venture capitalist",
      "code": "11-9199.03",
      "title": "Investment Fund Managers"
    },
    {
      "job": "veterinarian",
      "code": "29-1131.00",
      "title": "Veterinarians"
    },
    {
      "job": "veterinary assistant",
      "code": "31-9096.00",
      "title": "Veterinary Assistants and Laboratory Animal Caretakers"
    },
    {
      "job": "veterinary nurse",
      "code": "31-9096.00",
      "title": "Veterinary Assistants and Laboratory Animal Caretakers"
    },
    {
      "job": "video editor",
      "code": "27-4032.00",
      "title": "Film and Video Editors"
    },
    {
      "job": "videographer",
      "code": "27-4031.00",
      "title": "Camera Operators, Television, Video, and Motion Picture"
    },
    {
      "job": "vlogger",
      "code": "27-3022.00",
      "title": "Reporters and Correspondents"
    },
    {
      "job": "voice over actor",
      "code": "27-2011.00",
      "title": "Actors"
    },
    {
      "job": "waiter",
      "code": "35-3031.00",
      "title": "Waiters and Waitresses"
    },
    {
      "job": "web designer",
      "code": "15-1134.00",
      "title": "Web Developers"
    },
    {
      "job": "web developer",
      "code": "15-1134.00",
      "title": "Web Developers"
    },
    {
      "job": "welfare worker",
      "code": "21-1093.00",
      "title": "Social and Human Service Assistants"
    },
    {
      "job": "wildlife ranger",
      "code": "45-4011.00",
      "title": "Forest and Conservation Workers"
    },
    {
      "job": "workplace relations advisor",
      "code": "13-1075.00",
      "title": "Labor Relations Specialists"
    },
    {
      "job": "writer",
      "code": "27-3043.05",
      "title": "Poets, Lyricists and Creative Writers"
    },
    {
      "job": "youth liaison officer",
      "code": "21-1093.00",
      "title": "Social and Human Service Assistants"
    },
    {
      "job": "youth support worker",
      "code": "21-1093.00",
      "title": "Social and Human Service Assistants"
    },
    {
      "job": "air traffic controller",
      "code": "53-2021.00",
      "title": "Air Traffic Controllers"
    },
    {
      "job": "child care worker",
      "code": "39-9011.00",
      "title": "Childcare Workers"
    },
    {
      "job": "midwife",
      "code": "29-9099.01",
      "title": "Midwives"
    },
    {
      "job": "social scientist",
      "code": "19-3041.00",
      "title": "Sociologists"
    },
    {
      "job": "soldier",
      "code": "33-3051.01",
      "title": "Police Patrol Officers"
    }
  ]